import React, { useEffect, useRef } from "react";

import Animate, { SLIDES_ENGLISH_V3 } from "../Animate/Animate";
import { HeroCheckIcon, HeroUnderlineIcon } from "../../icons";

import "./IntensiveHero.css";

const LEAD_IFRAME_ORIGIN = "https://nxtwave-lead.netlify.app";
const LOGO_SRC =
  "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/intensive-english/nxtwave-intensive-logo.svg";

function useLeadIframeBridge(iframeRef) {
  useEffect(() => {
    const getIframe = () => iframeRef.current;

    function sendParentUrlContext() {
      const iframe = getIframe();
      if (!iframe?.contentWindow) return;
      iframe.contentWindow.postMessage(
        { type: "PARENT_URL_CONTEXT", url: window.location.href },
        LEAD_IFRAME_ORIGIN
      );
    }

    function sendUtmToChild() {
      const iframe = getIframe();
      if (!iframe?.contentWindow) return;
      const q = new URLSearchParams(window.location.search);
      const payload = {
        utm_source: q.get("utm_source") || "",
        utm_medium: q.get("utm_medium") || "",
        utm_campaign: q.get("utm_campaign") || "",
        utm_term: q.get("utm_term") || "",
        utm_content: q.get("utm_content") || "",
        gclid: q.get("gclid") || "",
        fbclid: q.get("fbclid") || "",
      };
      iframe.contentWindow.postMessage({ type: "UTM_PARAMS", payload }, LEAD_IFRAME_ORIGIN);
    }

    function onMessage(event) {
      if (event.origin !== LEAD_IFRAME_ORIGIN) return;

      if (event.data?.type === "DATALAYER_UPDATE") {
        window.dataLayer = window.dataLayer || [];
        const { payload } = event.data;
        if (Array.isArray(payload)) {
          payload.forEach((item) => {
            if (item && typeof item === "object") window.dataLayer.push(item);
          });
        } else if (payload && typeof payload === "object") {
          window.dataLayer.push(payload);
        }
        return;
      }

      const iframe = getIframe();
      if (!iframe?.contentWindow || event.source !== iframe.contentWindow) return;

      if (event.data?.type === "REQUEST_PARENT_UTM") sendUtmToChild();
      if (event.data?.type === "REQUEST_PARENT_URL_CONTEXT") sendParentUrlContext();
    }

    let loadTimeouts = [];

    function onIframeLoad() {
      sendUtmToChild();
      sendParentUrlContext();
      loadTimeouts.push(setTimeout(sendUtmToChild, 500));
      loadTimeouts.push(setTimeout(sendParentUrlContext, 500));
    }

    const iframe = getIframe();
    if (!iframe) return undefined;

    iframe.addEventListener("load", onIframeLoad);
    window.addEventListener("message", onMessage);
    sendUtmToChild();
    sendParentUrlContext();

    return () => {
      loadTimeouts.forEach(clearTimeout);
      iframe.removeEventListener("load", onIframeLoad);
      window.removeEventListener("message", onMessage);
    };
  }, [iframeRef]);
}

const HERO_BULLETS = [
  "Learn at our training center or online",
  "Work on 10+ real-time projects",
  "Prepare for placements with mock interviews",
  "Access opportunities from 3000+ hiring companies",
];

export default function IntensiveHero() {
  const leadIframeRef = useRef(null);
  useLeadIframeBridge(leadIframeRef);

  return (
    <section className="section-2809">
      <div
        data-animation="default"
        data-collapse="medium"
        data-duration="400"
        data-easing="ease"
        data-easing2="ease"
        role="banner"
        className="navbar w-nav"
      >
        <div className="container w-container">
          <a href="#top" className="brand-2 w-nav-brand">
            <img
              loading="lazy"
              src={LOGO_SRC}
              alt="NXT WAVE INTENSIVE logo"
              className="intensive-offline-logo"
            />
          </a>
        </div>
      </div>
      <div className="w-layout-blockcontainer intensive-container w-container">
        <div className="div-block-1831980521448963">
          <div>
            <h1 className="heading-3671145">
              A Proven Program To Help You Become a <br />
              <Animate slides={SLIDES_ENGLISH_V3} className="text-span-1792 hero-role-animate" />
            </h1>
            <HeroUnderlineIcon />
            <div className="div-block-1831980521448965">
              {HERO_BULLETS.map((text) => (
                <div key={text} className="div-block-1831980521448964">
                  <HeroCheckIcon />
                  <div className="text-block-941288240619">{text}</div>
                </div>
              ))}
            </div>
          </div>
          <div id="form-container" className="form-container-cont div-block-1831980521448962">
            <div className="code-embed-79 w-embed w-iframe">
              <iframe
                ref={leadIframeRef}
                id="lead-iframe"
                title="Book a free session"
                src="https://nxtwave-lead.netlify.app/"
                width="100%"
                height="600px"
                style={{ border: "none", overflow: "hidden" }}
                scrolling="no"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
